export const BOOKING_STATUS = {
  WAITING: "waiting",
  ACCEPTED: "accepted",
  DONE: "done",
  USER_CANCEL: "user_cancelled",
  SHOP_CANCEL: "shop_cancelled",
  NOT_SHOW: "not_show",
};
